import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import { ImArrowLeft, ImArrowRight } from "react-icons/im";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import fundo from "../../../styles/fundo.svg";
import "./style.css";

const Geral = styled.div`
  width: 98%;
  box-shadow: 0px 0px 2px #ccc;
  padding: 5px;
  background-color: #ffffff;
`;
const Table = styled.table`
  width: 99%;
  background-color: #fff;
  padding: 20px 20px;
  box-shadow: 0px 0px 2px #ccc;
  border-radius: 0.5px;
  margin: 5px auto;

`;

export const TdButton = styled.td`
  font-size: 14px;
  font-weight: bold;
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  cursor: pointer;
`;

export const Thead = styled.thead``;

export const Tbody = styled.tbody`
  padding-bottom: 25px; 
`;

export const Tr = styled.tr`
  text-align: center;
  text-decoration: none;
  border: none;
  width: 100%;
  background-color: #fff;
  cursor: pointer;
  transition: transform 0.3s;

  &:hover {
    color: black;
    background-color: #f5f5f5;
  }

`;

export const Th = styled.th`
  color: #4f4f4f;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;


`;

export const Td = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
 

`;

export const Td1 = styled.td`
  padding-top: 15px;
  text-align: center;


`;

export const Td2 = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
 
`;

export const Td3 = styled.td`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;

  span{
    margin: 0px 5px;
  }

`;

const Input = styled.input`
  width: 345px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 1px;
  height: 37px;


`;

const Button = styled.button`
  cursor: pointer;
  border: none;
  color: black;
  background-color: transparent;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.3);
  }
`;

const Div = styled.div`
display: flex;
align-items: center;

  
  span{
    padding: 0px  10px;
  }
`;


const ButtonExport = styled.td`
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  background-color: #ccc;
  color: white;
  border-radius: 5px;
  width: 50px;
  text-align: center;
  align-items: center;
  height: 20px;
  margin-left: 10px;
  &:hover {
    background-image:url(${fundo});
  }

  
`;


const Grid = ({ setOnEditTreinamentoPorUsuario, toggleTreinamentoPorUsuario, users }) => {

  const [searchTerm, setSearchTerm] = useState('');
  const [searchTermSetor, setSearchTermSetor] = useState('');
  const [filteredUsers, setFilteredUsers] = useState(users);
  const [isLoading, setIsLoading] = useState(true);





  //Input de pesquisa
  const handleSearch = async (term) => {
    setIsLoading(true);

    try {
      const filtered = users.filter((user) => {
        const nome = user.nome ? user.nome.toLowerCase() : ''; // Verifica se user.logon é null ou undefined

        return (
          nome.includes(term.toLowerCase())
        );
      });
      setFilteredUsers(filtered);
    } catch (error) {
      console.error("Erro ao pesquisar:", error);
    }

    setIsLoading(false);
    //setSearchTerm('');
  };

  useEffect(() => {

    handleSearch(searchTerm);
  }, [searchTerm, users]);

  const handleSearchSetor = async (term) => {
    setIsLoading(true);

    try {
      const filtered = users.filter((user) => {
        const departamento = user.departamento ? user.departamento.toLowerCase() : ''; // Verifica se user.logon é null ou undefined

        return (
          departamento.includes(term.toLowerCase())
        );
      });
      setFilteredUsers(filtered);
    } catch (error) {
      console.error("Erro ao pesquisar:", error);
    }

    setIsLoading(false);
    //setSearchTerm('');
  };

  useEffect(() => {

    handleSearchSetor(searchTermSetor);
  }, [searchTermSetor, users]);








  const handleEdit = (item) => {
    setOnEditTreinamentoPorUsuario(item);
    toggleTreinamentoPorUsuario();
  };



  const exportToExcel = () => {
    const dadosParaExportar = filteredUsers.map((item) => ({
      "Crachá": item.cracha,
      "Nome": item.nome,
      "Setor": item.departamento,

    }));

    // Criar uma planilha
    const ws = XLSX.utils.json_to_sheet(dadosParaExportar);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Departamentos");

    // Criar um arquivo Excel e baixar
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "relatorio_usuarios.xlsx");
  };



  //--------------------------------------------------------------------------------------------------------------//
  // Estados de Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Itens por página

  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...filteredUsers];

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValue = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValue = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [filteredUsers, sortConfig]);

  // Aplicação da Paginação (agora sobre os dados ordenados)
  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems2 = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  // Funções de Paginação
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
    setCurrentPage(1); // Reseta para a primeira página ao ordenar
  };

  //--------------------------------------------------------------------------------------------------------------//

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };



  return (

    <Geral>
      <Td3 colSpan="7">
        <Input
          type="text"
          placeholder="Pesquisar nome"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <Input
          type="text"
          placeholder="Pesquisar setor"
          value={searchTermSetor}
          onChange={(e) => setSearchTermSetor(e.target.value)}
        />

        <Div>
          <div>
            <Button onClick={handlePrevPage} disabled={currentPage === 1}><ImArrowLeft size={20} /></Button>
            <span>Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
            <Button onClick={handleNextPage} disabled={currentPage === totalPages}> <ImArrowRight size={20} /></Button>
          </div>
        </Div>

        <Div>
          <p>Exportar: </p>
          <ButtonExport onClick={exportToExcel}>Excel</ButtonExport>
        </Div>
      </Td3>
      <Table >

        <Thead>
          <Tr>

            <Th onClick={() => onColumnClick("cracha")} className={getSortClass("cracha")}>
              Crachá: {getSortIcon("cracha")}
            </Th>
            <Th onClick={() => onColumnClick("nome")} className={getSortClass("nome")}>
              Nome: {getSortIcon("nome")}
            </Th>
            <Th onClick={() => onColumnClick("departamento")} className={getSortClass("departamento")}>
              Setor: {getSortIcon("departamento")}
            </Th>

          </Tr>
        </Thead>
        <Tbody>
          {currentItems2.map((item, i) => (
            <Tr key={i} onClick={() => handleEdit(item)}>
              <Td>{item.cracha}</Td> {/* Título do treinamento */}
              <Td>{item.nome}</Td> {/* Data do treinamento */}
              <Td>{item.departamento}</Td>
            </Tr>
          ))}
        </Tbody>

      </Table>

    </Geral>
  );
};


export default Grid;
